import { connect } from 'react-redux';
import View from './LoadIndicatorComponent';
import {
  getDashboardAdvancedQuery, getMapChargersPerRequest,
  mapChargersAreLoaded,
  mapChargersAreLoading,
  mapChargersLoadedCount,
  mapChargersTotalCount,
} from '../../selectors';
import { getChargers } from '../../actions';

const mapStateToProps = (state) => ({
  isLoading: mapChargersAreLoading(state),
  isLoaded: mapChargersAreLoaded(state),
  totalCount: mapChargersTotalCount(state),
  loadedCount: mapChargersLoadedCount(state),
  query: getDashboardAdvancedQuery(state),
  perRequest: getMapChargersPerRequest(state),
});

const mapDispatchToProps = (dispatch) => ({
  reload: (query, requestId, perRequest) => dispatch(getChargers(query, requestId, perRequest)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  reload: (requestId) => dispatchProps.reload(stateProps.query, requestId, stateProps.perRequest),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(View);
